import ApiConstant from "../../constants/api.constants";
import Helpers from "../../utils/helpers";
import api from "../api";
//import sites_dd from "./data/sites_dd.json";
import allsites from "./data/allsites.json"

const baseURL = process.env.REACT_APP_SERVER_ENDPOINT_AURA_CAMERA;
const getAllSites = async (cusId?: any) => {
  try {
    const response = await api.get(baseURL + ApiConstant.getSites);
    if (response && response.data) {
      return response.data;
    }
    //return sites_dd;
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const downloadKMLSites = async (payload:any) => {
  try {
    const response = await api.get(baseURL + ApiConstant.downloadKMLSites);

    if (response && response.data ) {
      return response.data;
    }

    return Promise.resolve(allsites);
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const pinnedandUnpinnedSites = async (cameraSiteId:any) => {
  try {
    const response = await api.put(`${baseURL}${ApiConstant.pinnedandUnpinned}?cameraSiteId=${cameraSiteId}`);
 

    if (response && response.data ) {
      return response.data;
    }

  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const downloadJsonSites =  async (cameraSiteId:string, surveyDate:string) => {
  try {
    const response = await api.get(`${baseURL}${ApiConstant.downloadJsonSite}?cameraSiteId=${cameraSiteId}&surveyDate=${surveyDate}`); 
    if (response && response.data ) {
      return response.data;
    }

  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const downloadQuickSurveyReport = async (cameraSiteId: string, surveyDate: string, imageBase64: string) => {
  try {
    const formData = new FormData();
    formData.append('cameraSiteId', cameraSiteId);
    formData.append('surveyDate', surveyDate);
    formData.append('imageBase64', imageBase64);
    const response = await api.post(
      `${baseURL}${ApiConstant.downloadQuickSurveyReport}`,
      formData,
      { responseType: 'blob', headers: { 'Content-Type': 'multipart/form-data' } }
    );
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const getAllSitesByCustomer = async (customerId?: any,customerName?: any,modeOfOperation: any = 1) => {
  try {
    const response = await api.get(`${baseURL}${ApiConstant.getSitesByCustomerId}?customerId=${customerId}&customerName=${customerName}&modeOfOperation=${modeOfOperation}`); 
    if (response && response.data) {
      return response.data;
    }
  } catch (error) {
    Helpers.ConsoleLogError(error);
  }
};

const SitesService = {
  getAllSites,
  downloadKMLSites,
  pinnedandUnpinnedSites,
  downloadJsonSites,
  getAllSitesByCustomer,
  downloadQuickSurveyReport
};

export default SitesService;
